import React, { useState } from "react";
import TabBar from "~/admin/components/TabBar";
import useDataLoading from "~/admin/hooks/useDataLoading";
import useLayout from "~/hooks/useLayout";
import useMount from "~/hooks/useMount";
import CategoriesApi from "~/admin/apis/categories.api";
import SocialNetworksApi from "~/admin/apis/socialNetworks.api";
import CategoriesTab from "./CategoriesTab";
import SocialNetworksTab from "./SocialNetworksTab";
import PageDataLoader from "~/admin/components/PageDataLoader";

export default function ContentsPage() {
  const { setLayout } = useLayout();
  const [activeTab, setActiveTab] = useState("categories");
  const [categories, setCategories] = useState([]);
  const [socialNetworks, setSocialNetworks] = useState([]);

  const dataLoading = useDataLoading();

  const tabItems = [
    {
      key: "categories",
      title: "Catégories",
    },
    {
      key: "socialNetworks",
      title: "Réseaux sociaux",
    },
  ];

  useMount(() => {
    setLayout({
      title: "Contenus",
      activeMenuKeys: ["contents"],
    });
    loadData();
  });

  const loadData = async () => {
    dataLoading.start();
    setCategories([]);
    setSocialNetworks([]);

    let error = null;
    const data = await Promise.all([
      CategoriesApi.list(),
      SocialNetworksApi.list(),
    ]).catch((e) => {
      error = e;
      return null;
    });

    dataLoading.stop(error);

    if (data) {
      setCategories(data[0]);
      setSocialNetworks(data[1]);
    }
  };

  const changeTab = (key) => {
    setActiveTab(key);
  };

  return (
    <PageDataLoader isLoading={dataLoading.isLoading}>
      <div className="w-full h-screen text-white flex flex-col">
        <div className="w-full min-h-[60px] border-b-2 border-slate-700 flex justify-between items-center px-10">
          <TabBar
            items={tabItems}
            activeItem={activeTab}
            onChange={changeTab}
          />
          <div className="font-bold text-2xl">Contenus</div>
        </div>
        <div className="p-6 overflow-auto">
          {activeTab === "categories" && (
            <CategoriesTab categories={categories} reload={loadData} />
          )}
          {activeTab === "socialNetworks" && (
            <SocialNetworksTab
              socialNetworks={socialNetworks}
              reload={loadData}
            />
          )}
        </div>
      </div>
    </PageDataLoader>
  );
}
